import { useMutation } from '@tanstack/react-query';

import { getApiClient } from '@cast/api-client';
import type { ReportingMonetizationTier } from '@cast/types';

import { getReportingMonetizationBaseUrl } from './reportingMonetizationBaseUrl';
import {
  notifyReportingMonetizationApiError,
  redirectToExternalUrl,
} from './reportingMonetizationRedirect';

export const useCreateReportingCheckoutSessionMutation = () => {
  return useMutation({
    mutationFn: (tier: ReportingMonetizationTier) =>
      getApiClient().costReport.createReportingMonetizationCheckoutSession({
        body: { tier, baseUrl: getReportingMonetizationBaseUrl() },
      }),
    onSuccess: (response) => {
      redirectToExternalUrl(
        response,
        'Checkout session URL missing or invalid. Expected https://checkout.stripe.com/... from the API (not a relative /api or /v1 path).'
      );
    },
    onError: (error) => {
      notifyReportingMonetizationApiError(error, 'checkout');
    },
  });
};
